import React from "react";
import * as Styled from "./styles";

export default () => {
  return <Styled.Activity />;
};
